var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
import StudentFilterStatisticsDomainService from "../Domain/StudentFilterStatistics/StudentFilterStatistics.service";
import StudentSearchService from "../Domain/StudentSearch/StudentSearch.service";
const baseURL = "/aviso/filter";
export default class FilterService {
    static getDefaultFiltersForCurrentUser(personType) {
        return FetchService.getSingleResponse(baseURL + "/getDefaultFiltersForCurrentUser", { personType });
    }
    static getAllFiltersForCurrentUser(includeEveryoneFilter = true, mapToSelectOptionsFormat = false) {
        return FetchService.getSingleResponse(baseURL + "/getAllFiltersForCurrentUser", { includeEveryoneFilter }).then((filters) => {
            if (mapToSelectOptionsFormat) {
                // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'filter' implicitly has an 'any' type.
                return filters.map((filter) => ({
                    label: filter.name,
                    value: filter.id,
                    personType: filter.personType.name,
                    isFilter: true,
                }));
            }
            return filters;
        });
    }
    static getCustomFilterForAffiliation(affiliationId) {
        return FetchService.getSingleResponse(baseURL + "/getCustomFiltersForAffiliation", { affiliationId });
    }
    static getCustomFiltersForCurrentUser(personType) {
        return FetchService.getSingleResponse(baseURL + "/getCustomFiltersForCurrentUser", { personType });
    }
    static getFilter(filterId) {
        return FetchService.getSingleResponse(baseURL + "/get", { id: filterId });
    }
    static saveStudentSearchFilter(studentSearch) {
        return FetchService.postSingleResponse(baseURL + "/saveStudentListFilter", studentSearch);
    }
    static getStudentSearchValuesFromFilter(filterId) {
        return FetchService.get(baseURL + "/getStudentSearchValuesFromFilter", {
            filterId,
            // @ts-expect-error - TS2345 - Argument of type '({ filter, studentSearchValues }: { filter: any; studentSearchValues: any; }) => { filter: any; studentSearchValues: StudentSearch; }' is not assignable to parameter of type '(value: unknown) => { filter: any; studentSearchValues: StudentSearch; } | PromiseLike<{ filter: any; studentSearchValues: StudentSearch; }>'.
        }).then(({ filter, studentSearchValues }) => ({
            filter,
            studentSearchValues: StudentSearchService.fromJSON(studentSearchValues),
        }));
    }
    static getCountOfStudentsInFilter(filterId) {
        return FetchService.getSingleResponse(baseURL + "/getCountOfStudentsInFilter", {
            filterId,
        });
    }
    static isApplicationStatusFilterEnabled() {
        return FetchService.getSingleResponse(baseURL + "/isApplicationStatusFilterEnabled");
    }
    static serializeStudentSearchFilter(studentSearch) {
        console.log(studentSearch, "studentSearch");
        // properties we need to map to just ids:
        const idProperties = [
            "locations",
            "courseSuccessScoringGroups",
            "termSuccessScoringGroups",
            "tags",
            "noTags",
            "degrees",
            "noDegrees",
            "courses",
            "registrationTerms",
            "noRegistrationTerms",
            "holds",
            "noHolds",
            "applicationStatuses",
            "applicationTerms",
            "programs",
            "noPrograms",
            "majors",
            "noMajors",
            "minors",
            "noMinors",
            "concentrations",
            "noConcentrations",
            "specializations",
            "noSpecializations",
            "races",
            "noRaces",
            "highSchools",
            "noHighSchools",
            "studentTypes",
            "noStudentTypes",
            "studentStatuses",
            "noStudentStatuses",
            "ethnicities",
            "noEthnicities",
            "applicationTypes",
            "noApplicationTypes",
            "veteranTypes",
            "noVeteranTypes",
            "courseSections",
            "terms",
            "state",
            "importProcesses",
            "highSchoolTranscriptStatus",
            "noHighSchoolTranscriptStatus",
            "highSchoolTranscriptType",
            "noHighSchoolTranscriptType",
            "highSchoolGraduationType",
            "noHighSchoolGraduationType",
            "applicationStudentLoadIntent",
            "noApplicationStudentLoadIntent",
            "applicationResidencyStatus",
            "noApplicationResidencyStatus",
            "applicationAdmitStatus",
            "noApplicationAdmitStatus",
            "applicationStudentType",
            "noApplicationStudentType",
            "applicationLocations",
            "noApplicationLocations",
            "pipelines",
            "stages",
            "intendedStartTerms",
            "noIntendedStartTerms",
            "interestedPrograms",
            "noInterestedPrograms",
            "interestedDepartments",
            "noInterestedDepartments",
            "searchFilterSubmittedForms",
            "noSearchFilterSubmittedForms",
            "submittedFormsAnswerInterestedPrograms",
            "noSubmittedFormsAnswerInterestedPrograms",
            "submittedFormsAnswerIntendedStartTerms",
            "noSubmittedFormsAnswerIntendedStartTerms",
            "submittedFormsAnswerDepartmentInterests",
            "noSubmittedFormsAnswerDepartmentInterests",
            "prospectSources",
            "noProspectSources",
        ];
        const personIdProperties = [
            "coaches",
            "advisors",
            "pipelineStaff",
            "inPersonsCaseload",
        ];
        const mapToProperty = (propertyName, list) => 
        // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments. | TS7006 - Parameter 'sum' implicitly has an 'any' type. | TS7006 - Parameter 'prop' implicitly has an 'any' type.
        list.reduce((sum, prop) => {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ObjMap<StudentSearch, <T>(arg1: T) => T | null | undefined>>'.
            if (!studentSearch[prop]) {
                return sum;
            }
            return Object.assign(Object.assign({}, sum), { 
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                [prop]: studentSearch[prop].map((item) => item[propertyName]) });
        }, {});
        return Object.assign(Object.assign(Object.assign({}, studentSearch), mapToProperty("id", idProperties)), mapToProperty("personId", personIdProperties));
    }
    static getCaseloadFilterId(personType) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'number'.
            return FetchService.getSingleResponse(baseURL + "/getCaseloadFilterId", {
                personType,
            }).then((response) => response);
        });
    }
    static getEveryoneFilterId(personType) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(baseURL + "/getEveryoneFilterId", {
                personType,
            });
        });
    }
    static allEveryoneFilterIds() {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(baseURL + "/allEveryoneFilterIds");
        });
    }
    static allCaseloadFilterIds() {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(baseURL + "/allCaseloadFilterIds");
        });
    }
    static getDefaultFilterId(personType) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(baseURL + "/getCaseloadFilterId", {
                personType,
            });
        });
    }
    static saveFilter(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.post("/filters", filter);
            return response.data;
        });
    }
    static fetchFilters(sort, page, size) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/filters", {
                params: { sort, page, size },
            });
            return response.data;
        });
    }
    static fetchFiltersGrouped(virtualizedAppName) {
        return FetchService.getPagedResponse("/aviso/filter/filtersGroupedByFilterSourcesForCurrentUser", {
            isCreatedByReportBuilder: true,
            expired: false,
            virtualizedAppNames: [virtualizedAppName],
        }).then((response) => {
            return response.data;
        });
    }
    static search(filterSearchArgs) {
        return FetchService.getSingleResponse("/aviso/filter/search", Object.assign({}, filterSearchArgs));
    }
    static fetchFiltersForPerson(pageSize, pageIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/filters/findAllAccessibleByPersonByFilterSource", { params: { size: pageSize, page: pageIndex } });
            return { content: response.data.content, hasNext: !response.data.last };
        });
    }
    static fetchFiltersByFilterSourceId(filterSourceId, pageSize, pageIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/filters/findAllAccessibleByPersonByFilterSource", { params: { filterSourceId, size: pageSize, page: pageIndex } });
            return { content: response.data.content, hasNext: !response.data.last };
        });
    }
    static fetchFilter(filterId) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get(`/filters/${filterId}`);
            return response.data;
        });
    }
    static runFilter(filter) {
        // This method uses the legacy Grails app to run the report (for now)
        return FetchService.post("/aviso/filter/runFilter", {
            filter,
        });
    }
    /**
     * This fetches the built-in reports in a grouped format. Does NOT include filters created in report builder.
     */
    static fetchBuiltInReportsGrouped(virtualizedAppName) {
        // This method uses the legacy Grails app to load the report groups
        return FetchService.getSingleResponse("/aviso/report/list", {
            format: "json",
            virtualizedApp: virtualizedAppName,
        });
    }
    static deleteFilter(filterId) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.delete(`/filters/${filterId}`);
            return response;
        });
    }
    static deleteFilterLegacy(filterId) {
        return FetchService.deleteSingleResponse(baseURL + "/deleteFilter", {
            filterId,
        });
    }
    static exportFilterToCsv(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            // This method uses the legacy Grails app to export the report to CSV.
            return FetchService.post("/aviso/filter/filterToExcel", filter);
        });
    }
    static getStatistics(filterId, period, rangeFrom, rangeTo) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield getApiClient().get("/stats/searchStudentFilterStats", {
                params: {
                    filterId,
                    period,
                    rangeFrom,
                    rangeTo,
                },
            });
            return data === null || data === void 0 ? void 0 : data.map(StudentFilterStatisticsDomainService.fromJSON);
        });
    }
}
